

import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { PDFDownloadLink } from '@react-pdf/renderer'
import ApiService from '../../../services/ApiService'

import { X } from 'lucide-react'

import CertificatePDFGenerator from '../CertificatePDFGenerator/PDFTemplate'
import PreviewModal from '../CertificatePDFGenerator/PreviewModal'
import type { CertificatePDFData } from '../CertificatePDFGenerator/types'
import { mapCertificateApiToPdfData } from '../utils/mapCertificateApiToPdfData'
import ModalTest from '../../BaseModal'
import { ModalContainer, CloseModal } from './style'

const ViewCertificateModal: React.FC = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [certificate, setCertificate] = useState<CertificatePDFData | null>(null)
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false)

 useEffect(() => {
   if (!id) {
     console.error('ID do certificado não encontrado na URL.')
     navigate('/panel/certificates')
     return
   }

   Promise.all([
     ApiService.certificates.findById(Number(id)),
     ApiService.certificates.getUtils(Number(id))
   ])
   .then(([response1, response2]: any[]) => {
     const dataFromFindOne = response1.data
     const dataFromUtilsView = response2.data
     const mappedData = mapCertificateApiToPdfData(
       dataFromFindOne,
       dataFromUtilsView,
       Number(id),
     )
     setCertificate(mappedData)
   })
   .catch((error: any) => {
     console.error('Erro ao carregar certificado:', error)
     alert('Erro ao carregar o certificado. Por favor, tente novamente.')
     navigate('/panel/certificates')
   })
 }, [id, navigate])

 if (!certificate) return <p>Carregando certificado...</p>

 const handleVerPreviewClick = () => {
   setIsPreviewModalOpen(true)
 }

 return (
   <ModalTest>
     <ModalContainer>
       <CloseModal onClick={() => navigate('..')}>
         <X color="#696969" />
       </CloseModal>
       <div
         style={{
           display: 'flex',
           flexDirection: 'column',
           alignItems: 'center',
           justifyContent: 'center',
           height: '100%',
           padding: '2rem',
           textAlign: 'center',
         }}
       >
         <h2 style={{ marginBottom: '1rem', color: '#1e40af' }}>
           Certificado #{certificate.id}
         </h2>
         <p style={{ marginBottom: '2rem', color: '#6b7280' }}>
           Cliente: {certificate.customer} | Nº da Corrida:
           {' '}
           {certificate.heatNumber}
           {certificate.responsibleName &&
             ` | Responsável: ${certificate.responsibleName}`}
         </p>

         {certificate.id !== 0 && (
           <div style={{ display: 'flex', gap: '15px', marginTop: '20px' }}>
             <button
               onClick={handleVerPreviewClick}
               style={{
                 padding: '10px 20px',
                 backgroundColor: '#f0f0f0',
                 color: '#1e40af',
                 borderRadius: '5px',
                 cursor: 'pointer',
                 fontSize: '16px',
                 border: '1px solid #1e40af',
                 display: 'inline-block',
               }}
             >
               Ver Preview
             </button>
             <PDFDownloadLink
               document={<CertificatePDFGenerator certificate={certificate} />}
               fileName={`Certificado_${certificate.id}_${certificate.customer}.pdf`}
               style={{
                 textDecoration: 'none',
                 padding: '10px 20px',
                 backgroundColor: '#1e40af',
                 color: 'white',
                 borderRadius: '5px',
                 cursor: 'pointer',
                 fontSize: '16px',
                 border: 'none',
                 display: 'inline-block',
               }}
             >
               {({ loading }) =>
                 loading ? 'Preparando Certificado...' : 'Baixar Certificado'
               }
             </PDFDownloadLink>
           </div>
         )}
       </div>
       {certificate && (
         <PreviewModal
           certificate={certificate}
           isOpen={isPreviewModalOpen}
           onClose={() => setIsPreviewModalOpen(false)}
         />
       )}
     </ModalContainer>
   </ModalTest>
 )
}

export default ViewCertificateModal
